<template>
  <div class="m-auto m-1230">
    <div class="row align-items-center">
      <div class="col-lg-6 d-none d-lg-block">
        <img src="@/assets/images/login.jpg" class="rounded-3" alt="login" />
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto">
          <div class="d-inline-block mb-4">
            <img
              src="@/assets/images/logo.svg"
              class="rounded-3 for-light-logo"
              alt="login"
            />
            <img
              src="@/assets/images/white-logo.svg"
              class="rounded-3 for-dark-logo"
              alt="login"
            />
          </div>
          <h3 class="fs-28 mb-2">Welcome back to Trezo!</h3>
          
          <form>
            <div class="form-group mb-3">
              <label class="label text-secondary">Email Address</label>
              <input
                type="email"
                class="form-control"
                placeholder="example@trezo.com"
              />
            </div>
            <div class="form-group mb-3">
              <label class="label text-secondary">Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Type password"
              />
            </div>
            <div class="form-group mb-3">
              <button
                type="submit"
                class="btn btn-primary fw-medium py-2 px-3 w-100"
              >
                <div
                  class="d-flex align-items-center justify-content-center py-1"
                >
                  <i class="material-symbols-outlined text-white fs-20 me-2">
                    login
                  </i>
                  <span>Login</span>
                </div>
              </button>
            </div>
            <div class="form-group">
              <p>
                Don’t have an account.
                <RouterLink
                  to="/register"
                  class="fw-medium text-primary text-decoration-none"
                >
                  Register
                </RouterLink>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LogOut",
});
</script>
